import PropTypes from "prop-types";
import styled from "styled-components";

import colors from "@/styles/colors";

const BottomMenu = styled.div``;

const StyledBottomMenuItem = styled.div`
    display: flex;
    height: 43px;
    user-select: none;
    padding: 0 32px 0 32px;
    align-items: center;
    color: ${colors.night};

    .button-icon {
        margin: 0 8px 0 0;
        font-size: 18px;
    }

    &&:first-child {
        border-top: 1px solid ${colors.blizzardGray};
    }
    &&:hover {
        cursor: pointer;
        background-color: ${colors.night};
        color: white;
    }
    &&:active {
        background-color: ${colors.nightSelected};
    }
    &&:hover i,
    &&:active i {
        color: white;
    }
    border-bottom: 1px solid ${colors.blizzardGray};
`;

const BottomMenuItem = (props) => (
    <StyledBottomMenuItem onClick={props.onClick}>
        <i className={`button-icon fal fa-${props.icon}`} />
        {props.children}
    </StyledBottomMenuItem>
);

BottomMenuItem.propTypes = {
    icon: PropTypes.string,
    onClick: PropTypes.func,
    children: PropTypes.node.isRequired,
};

BottomMenu.Item = BottomMenuItem;

export default BottomMenu;
